import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { STATUS } from '../models/status';
import { HttpService } from './http.service';

@Injectable()
export class VerificationsService {
  constructor(private http: HttpService) {}

  getVerifications(
    type: string,
    page: number = 1,
    page_size: number = 10,
    verificationId: number | null = null,
    q: string | null = null,
  ) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', page_size.toString());

    if (verificationId !== null && verificationId !== undefined) {
      params = params.set('id', verificationId.toString());
    }

    if (q && q.trim()) {
      params = params.set('q', q.trim());
    }

    const baseUrl = `verification/${type}`;
    return this.http.get(baseUrl, params);
  }

  updatePersonalStatus(body: any, id: any) {
    const baseUrl = `verification/personal/${id}`;
    return this.http.patch(baseUrl, body);
  }

  updateBusinessStatus(body: any, id: any) {
    const baseUrl = `verification/business/${id}`;
    return this.http.patch(baseUrl, body);
  }

  /** Admin: genera URL del proveedor externo y persiste en metadata del usuario. */
  generateVerificationLink(body: {
    verification_id: number;
    verification_type: 'kyc' | 'kyb';
    country_code?: string;
  }) {
    return this.http.post('verification/generate-link', body);
  }

  /**
   * Admin: crea solicitud KYC/KYB nueva (usuario + fila) y devuelve verification_url Sumsub.
   */
  createVerificationAndSumsubLink(body: {
    verification_type: 'kyc' | 'kyb';
    username: string;
    password: string;
    confirm_password: string;
    email?: string;
    first_name?: string;
    middle_name?: string;
    surname?: string;
    second_surname?: string;
    document_type?: 'DNI' | 'PASSPORT' | 'PHOTO_LICENSE';
    document_number?: string;
    company_name?: string;
    brand_name?: string;
    company_registration_number?: string;
    company_email?: string;
    address_line_1: string;
    address_line_2?: string;
    city: string;
    postal_code: string;
    state: string;
    country: string;
    country_code?: string;
  }) {
    return this.http.post('verification/admin/create-sumsub-link', body);
  }

  /**
   * Envía nueva verificación KYC (personal). La API devuelve verification_id y account_creation_token.
   * Tras el éxito, usar startVerification() con ese token para obtener la URL de verificación externa.
   */
  addPersonalVerification(body: any) {
    return this.http.post('verification/personal', body);
  }

  /**
   * Envía nueva verificación KYB (empresa). La API devuelve verification_id y account_creation_token.
   * Tras el éxito, usar startVerification() con ese token para obtener la URL de verificación externa.
   */
  addBusinessVerification(body: any) {
    return this.http.post('verification/business', body);
  }

  /**
   * Inicia el flujo de verificación externa (KYC/KYB).
   * payload: { verification_id, verification_type: 'kyc'|'kyb', account_creation_token, country_code? }
   * Retorna verification_url para redirigir al usuario (Observable).
   */
  startVerification(payload: {
    verification_id: number;
    verification_type: 'kyc' | 'kyb';
    account_creation_token: string;
    country_code?: string;
  }) {
    return this.http.post('verification/start', payload);
  }

  /**
   * Comprueba si ya existe una solicitud pendiente para este email (evitar duplicados).
   * GET verification/status?email=...&type=kyc|kyb. Retorna { has_pending: boolean, verification_id?: number }.
   */
  getVerificationStatus(email: string, type: 'kyc' | 'kyb') {
    const params = new HttpParams()
      .set('email', email)
      .set('type', type);
    return this.http.get('verification/status', params);
  }
}
